import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MaterialModule } from '../../material.module';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-statuscode-additional-details',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './statuscode-additional-details.component.html',
  styleUrl: './statuscode-additional-details.component.scss',
})


export class StatuscodeAdditionalDetailsComponent implements OnInit {
  public form!: FormGroup;
  public rowData: any;
  constructor(private readonly fb: FormBuilder) {}

  ngOnInit() {
    this.form = this.fb.group({
      notes: ['']
    });
     if (this.rowData) {
    this.patchForm(this.rowData);
  }
  }
  
  private patchForm(data: any) {
  this.form.patchValue({
    notes: data.description ?? '',
  });
  if(!data?.isInputRow){
    this.form.disable();
  }
}


  get notes() {
    return this.form.get('notes');
  }
}